import mock from "./mock";
import "./jwt";

mock.onAny().passThrough();
